/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const UserSettingKey = {
    MINIMIZED_MENU: 'MINIMIZED_MENU'
} as const;
export type UserSettingKey = typeof UserSettingKey[keyof typeof UserSettingKey];

